export default __webpack_public_path__ + "static/media/banner7 2.6b8d496a.png";